import * as React from 'react';
import { Search } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { ids } from 'app/area/administration/constants';
import { SearchFiltersTranslation } from '../constants';
import { SearchAttributes } from './search-attributes';
import { QueryConfigurationProps } from './types';
import styles from './search-layout.scss';

import type { JSX } from "react";

interface SearchLayoutProps {
  translation: SearchFiltersTranslation;
  querySettings: QueryConfigurationProps;
  rightToolbar: JSX.Element;
  topToolbar: JSX.Element;
  hideSearch: boolean;
  onSearch: () => void;
}

export const SearchLayout: React.FC<SearchLayoutProps> = ({
  topToolbar, rightToolbar, hideSearch, translation, querySettings, onSearch
}) => (
  <div className={styles.searchHeader}>
    <MainGridContainer>
      {!hideSearch && (topToolbar || null)}
      {!hideSearch && !!querySettings && <div className="row">
        <div id={ids.list_search} className="col-lg-8 col-md-12">
          <Search
            className={`${styles.searchField} input-wrapper`}
            componentId={ids.search.box}
            onChange={querySettings.onChangeQuery}
            value={querySettings.query}
            minLength={1}
            maxLength={255}
            onSearch={onSearch}
            placeholder={translation.search}
            focus={true} />
          <SearchAttributes translation={translation} {...querySettings} />
        </div>
        {!!rightToolbar && <div className="col-lg-4 col-md-12">
          <div className={styles.searchToolbar}>
            {rightToolbar}
          </div>
        </div>}
      </div>}

      {!!hideSearch && <div className="row">
        {topToolbar || null}
        {!!rightToolbar && <div className="col-lg-4 col-md-12">
          <div className={styles.searchToolbar}>
            {rightToolbar}
          </div>
        </div>}
      </div>}
    </MainGridContainer>
  </div>
);
